// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"168":"2840e6db7bd68ffc432b","244":"08a3fd4d92fb2c90bd98"}[chunkId] + ".js";
};